module.exports = __webpack_public_path__ + "img/collection-weddingRingsFacetes@2x.0cfa585.webp";